// dependencies
import { Map } from "immutable";

const initialState = Map({
	page: Map(),
});

export default function navigation(state = initialState, action) {
	switch (action.type) {
		case "ROUTER_LOCATION_CHANGED":
			return state.withMutations((nest) => {
				const props = action.payload.props;

				Object.keys(props).forEach((key) => {
					nest.setIn(["page", key], props[key]);
				});
			});
		default:
			// never forget your default return state!
			return state;
	}
}
